module.exports = { "default": require("core-js/library/fn/object/values"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/~/babel-runtime/core-js/object/values.js
 ** module id = 92
 ** module chunks = 0
 **/